<template>
  <div
    v-if="content"
    class="HomeIntro"
  >
    <div class="HomeIntro__container">
      <div class="HomeIntro__title">
        <TextIntroMobile class="HomeIntro__title--svg mobile" />
        <TextIntro class="HomeIntro__title--svg desktop" />
      </div>

      <div class="HomeIntro__content">
        <h2
          class="HomeIntro__content--text"
          v-html="content.intro_subtitle"
        />
      </div>
    </div>
  </div>
</template>

<script>
import imageKit from "@/mixins/image-kit";
import { InertiaLink, usePage } from "@inertiajs/inertia-vue3";

export default {

  mixins: [imageKit],
  props: {
    position:{
      type: Number,
      default: 1000
    },
    content: {
      type: Object,
      default: () => {}
    },

  },
};
</script>

<style lang="scss" scoped>
.HomeIntro{
  padding-top: 79px;
  width: 100%;

  &__container{
      display: flex;
      flex-wrap: wrap;
      padding-top: 10vh;
      padding-bottom: 15vh;
      width: 100%;
      @include paddingMobile;




      @include tablet {
        @include paddingPageTop;
        @include paddingMedium;
        @include paddingSectionBottom;

        align-items: center;
      }
    }

    &__title{
        width: 100%;
        margin-bottom: 2.7vh;

        @include tablet {
          @include marginBottomSmall;

          padding-bottom: 0;
        }

      @include tablet {
        width: 80%;
      }


      @include desktop-s {
        width: 50%;
        margin-bottom: 0;
      }


      &--svg{
        width: 98%;
        height: auto;
        &.desktop{
          display: none;
          margin-left: -2px;
        }
        @include tablet {
           width: 100%;

          &.mobile{
            display:none;
          }
          &.desktop{
            display: block;
          }
        }
        @include desktop-l {
          width: 95%;
        }

        @include desktop-xl {
          width: 90%;
        }

      }
    }

    &__content{
      display: flex;
      width: 100%;

      @include desktop-s {
        width: 50%;
        justify-content: flex-end;
      }


      &--text{
        width: fit-content;

          @include desktop-s {
              transform: translateY(-0.4vw);
          }

        * {
          font-size: 20px ;
          line-height: 1.4 ;
         font-variation-settings: 'wght' 500, 'wdth' 100, 'opsz' 30;

          @include mobile{
              font-size: 24px ;
          }

          @include tablet{
              font-size: 26px ;
          }

          @include desktop-s {
            font-size: 1.7vw;
          }

          @include desktop-l {
            font-size: 1.6vw;
          }
          @include desktop-xl {
            font-size: 1.5vw;
          }
        }


      }
    }
}
</style>
